'use client'
import Image from 'next/image'
import { Button, Tag } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useAsyncEffect } from 'ahooks'
import {
  useCommittee,
  useContractStore,
  useBindWalletAddress,
  useLockToken,
  useUserStore,
} from '@hooks/index'
import { parseToFloat, wrapUnits } from '@utils/index'
import UserInfoButton from './UserInfoButton'
import UserInfoInput from './UserInfoInput'


export default function UserInfoPage() {
  const user = useUserStore()
  const contract = useContractStore()
  const {
    handleConnectWallet,
    handleBindWallet,
    bindWalletLabel,
    boundAddress,
    activeAddress,
    governanceAddress,
    hasActiveWallet,
    isAddressMismatch,
    shouldShowBindWalletAction,
    isLocalChainMode,
  } = useBindWalletAddress()
  const updateUser = useUserStore((state) => state.updateUser)
  const { token } = useLockToken(governanceAddress)
  const { isCommittee } = useCommittee(governanceAddress)
  const hasProfile = !!user.user.avatar
  const displayName =
    user.user.nickname
    || user.user.github_account
    || boundAddress
    || activeAddress
    || 'Wallet'

  useAsyncEffect(async () => {
    if (user.isLogin()) {
      await updateUser()
    }
  }, [])

  return (
    <div className='flex flex-col px-40 mt-20 pb-80'>
      <div className='flex items-center'>
        {hasProfile ? (
          <Image
            className='h-16 w-16 rounded-full overflow-hidden'
            src={user.user.avatar || ''}
            alt='user avatar'
            width={64}
            height={64}
          />
        ) : (
          <div className='w-16 h-16 rounded-full overflow-hidden bg-gray-100 text-gray-500 flex items-center justify-center'>
            <UserOutlined className='text-2xl' />
          </div>
        )}
        <h2 className='ml-4 text-2xl cursor-default text-cyfs-green'>
          {displayName}
        </h2>
        {isCommittee && (
          <div className='ml-2'>
            <Tag color='green'>committee</Tag>
          </div>
        )}
      </div>

      <div className='leading-10'>
        <UserInfoInput />

        <div className=''>
          <label className='inline-block w-48 font-bold'>
            github account id
          </label>
          <span>{user.user.github_account}</span>
        </div>

        <div>
          <label className='inline-block w-48 font-bold'>bound wallet</label>
          <span>{boundAddress || '-'}</span>
        </div>

        <div>
          <label className='inline-block w-48 font-bold'>active wallet</label>
          <span>{activeAddress || '-'}</span>

          {!hasActiveWallet && (
            <Button className='ml-10' type='primary' onClick={handleConnectWallet}>
              Connect wallet
            </Button>
          )}
        </div>
        {shouldShowBindWalletAction && (
          <div>
            <label className='inline-block w-48 font-bold'>bind action</label>
            <Button className='ml-0' type='primary' onClick={handleBindWallet}>
              {bindWalletLabel}
            </Button>
          </div>
        )}
        {isLocalChainMode && hasActiveWallet && !boundAddress && (
          <div>
            <label className='inline-block w-48 font-bold'>wallet status</label>
            <Tag color='blue'>Local test mode skips wallet binding</Tag>
          </div>
        )}
        {isAddressMismatch && (
          <div>
            <label className='inline-block w-48 font-bold'>wallet status</label>
            <Tag color='warning'>Active wallet differs from bound address</Tag>
          </div>
        )}
        {governanceAddress && (
          <>
            <div>
              <label className='inline-block w-48 font-bold'>Total Token</label>
              {wrapUnits(token.token, contract.decimals)}
              {contract.symbol}
            </div>
            <div>
              <label className='inline-block w-48 font-bold'>Assigned Lockup</label>
              {parseToFloat(token.assigned)}
              {contract.symbol}
            </div>

            <div>
              <label className='inline-block w-48 font-bold'>Claimed Lockup</label>
              {parseToFloat(token.claimed)}
              {contract.symbol}
            </div>

            <div>
              <label className='inline-block w-48 font-bold'>Remaining Locked</label>
              {parseToFloat(token.locked)}
              {contract.symbol}
            </div>
          </>
        )}
      </div>
      <UserInfoButton />
    </div>
  )
}
